<div class="menu-item">
  <div class="menu-content pt-8 pb-2">
    <span class="menu-section text-muted text-uppercase fs-8 ls-1">{{
      menu.title | translate
    }}</span>
  </div>
</div>
@for (sub_menu of menu.children; track $index) {
<section>
  <!-- Menu Section accordion -->
  @if (sub_menu.type === 'accordion') {
  <app-side-menu-accordion [menu]="sub_menu"></app-side-menu-accordion>
  }
  <!-- Menu Section item -->
  @if (sub_menu.type === 'item') {
  <div class="menu-item">
    <app-side-menu-item [menu]="sub_menu"></app-side-menu-item>
  </div>
  }
</section>
}
